export default function () {
    let w = 600;
    let h = 800;
    var left = screen.width / 2 - w / 2;
    var top = screen.height / 2 - h / 2;
    // window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);

    // if(localStorage.getItem('app')){
    // alert('cordova.InAppBrowser', typeof (cordova));
    //     window.open = cordova.InAppBrowser.open;
    // }

    var url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(location.href);

    // return window.open(url, '_system', 'location=yes');

    return window.open(
        url,
        "_system",
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
        w + ", height=" + h + ", top=" + top + ", left=" + left
    );
}